import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { formatMoney } from 'utils/storefront/format-resource';
import clsx from 'clsx';

const RewardBalance = ({
   isMelanieLyne,
   showInCart,
   cartIsEmpty,
   onChange
}) => {
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    if (onChange) {
      onChange(balance);
    }
  }, [balance]);

  useEffect(() => {
    if (window.TMW.crmId) {
      const sessionRewardsBalance = sessionStorage.getItem('rewardsBalance');
      if (sessionRewardsBalance !== null) {
        const result = JSON.parse(sessionRewardsBalance);
        if (!result.amount) return;
        setBalance({
          currencyCode: result.currencyCode,
          amount: parseFloat(result.amount),
        });
      }

      window.Cardigan.api.getRewardsBalance({
        id: window.TMW.crmId,
        onSuccess: (result) => {
          sessionStorage.setItem(
            'rewardsBalance',
            `{"currencyCode":"${result.reward.currency}","amount":"${parseFloat(
              result.reward.balance,
            )}"}`,
          );
          setBalance({
            currencyCode: result.reward.currency,
            amount: parseFloat(result.reward.balance),
          });
        },
        onError: (result) => {
          // eslint-disable-next-line no-console
          console.error(
            'components/header/reward-balance.js: Balance fetch error.',
            result,
          );
        },
      });
    } else {
      // If the customer is not logged in or doesn't have a crmId reset the field
      setBalance({
        amount: 0,
      });
      sessionStorage.removeItem('rewardsBalance');
    }
  }, []);

  if (balance?.amount > 0) {
    return (
      <div
        className={clsx({
          'body-2 text-center lc:bg-accent-1 ml:bg-accent-2 p-8': showInCart,
          'mx-24': showInCart && cartIsEmpty,
          'body-6': !showInCart,
          'text-subdued': !isMelanieLyne && !showInCart,
        })}
      >
        {window.TMW.Strings.account.rewardBalance.replace(
          '{{amount}}',
          formatMoney(balance, false),
        )}
      </div>
    );
  }

  return null;
};

export default RewardBalance;
